module.exports = __webpack_public_path__ + "media/images/lb/716-1df19cad9f4b7ff5f9ba48ef9bb4acf3.svg";